import {
  BrowserCacheLocation,
  Configuration,
  LogLevel,
} from "@azure/msal-browser"

export const msalConfig: Configuration = {
  auth: {
    clientId: "528ec822-7db7-496d-baf1-a6586dbec723",
    authority: "https://login.microsoftonline.com/nsbas.onmicrosoft.com",
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean,
      ) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Info:
            console.info(message)
            return
          case LogLevel.Verbose:
            console.debug(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            break
          default:
            break
        }
      },
    },
  },
}

export const loginRequest = {
  scopes: ["api://528ec822-7db7-496d-baf1-a6586dbec723/taxi.admin"],
}
